import { border } from "polished";

export const px = 4;
export const py = 3;

export const getBorder = (side: "top" | "bottom") =>
  border(side, "1px", "solid", "borders");
